export const projetos = {
  titulo: 'Projetos',
  descricao: 'Consulta dos projetos cadastrados no Axiis.',
  avisoEdicao: 'Se quiser editar o projeto por completo, edite no Axiis BR ou no Axiis US.',
  total_one: 'Mostrando {{showing}} de {{count}} projeto',
  total_other: 'Mostrando {{showing}} de {{count}} projetos',
  colunas: {
    codigo: 'Cód. Axis',
    nome: 'Nome',
    unidade: 'Unidade',
    cliente: 'Cliente',
    contrato: 'Contrato',
    situacao: 'Situação',
    inicio: 'Início',
    termino: 'Término',
    gerenteProjeto: 'Gerente de projeto',
    gerenteOperacao: 'Gerente de operação',
    diretorConta: 'Diretor de conta',
    interno: 'Interno',
    pool: 'Pool',
  },
  situacoes: {
    emAndamento: 'Em andamento',
    emContratacao: 'Em contratação',
    cancelado: 'Cancelado',
    encerrado: 'Encerrado',
    emGarantia: 'Em garantia',
    desconhecida: 'Situação desconhecida',
  },
  filtros: {
    avancadosDescricao: 'Filtre por unidade, código Axis, nome, contrato, interno ou pool.',
    todos: 'Todos',
  },
  tabela: {
    vazioTitulo: 'Nenhum projeto para mostrar',
    vazioDescricao: 'Não há projetos no seu escopo.',
    filtroSemResultadoTitulo: 'Nenhum projeto com esses filtros',
    filtroSemResultadoDescricao: 'Ajuste ou limpe os filtros para ver os projetos.',
  },
  edicao: {
    titulo: 'Editar projeto',
    aviso:
      'Apenas os campos Gerente de projeto, Gerente de operação, Diretor de conta, Interno e Pool são editáveis aqui. Para editar o projeto por completo, acesse o Axiis BR ou o Axiis US.',
    id: 'Id',
    selecionar: 'Selecionar',
    acoes: 'Ações',
    editarProjeto: 'Editar projeto {{nome}}',
    toastSucesso: 'Projeto atualizado.',
    toastErro: 'Não foi possível salvar o projeto.',
  },
  exportacao: {
    nomeArquivo: 'projetos',
    botao: 'Exportar',
    titulo: 'Exportar projetos',
    descricao: 'O arquivo segue os filtros aplicados e as colunas visíveis na tela.',
    escopo: 'O que exportar',
    paginaAtual_one: 'Somente esta página ({{count}} projeto)',
    paginaAtual_other: 'Somente esta página ({{count}} projetos)',
    todos_one: 'Todos os projetos ({{count}} projeto)',
    todos_other: 'Todos os projetos ({{count}} projetos)',
    todosFiltrados_one: 'Todos os resultados dos filtros ({{count}} projeto)',
    todosFiltrados_other: 'Todos os resultados dos filtros ({{count}} projetos)',
    unicaPagina_one: 'Será exportado {{count}} projeto.',
    unicaPagina_other: 'Serão exportados {{count}} projetos.',
    formato: 'Formato',
  },
} as const;
